import * as React from 'react'
import { observer } from 'mobx-react'
import { JobListViewModel } from '../JobListViewModel'
import { SplitViewHeader, SplitViewHeaderSearch } from 'components/SplitView'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: JobListViewModel
  scrollOffset: ScrollOffsetInterpolation
}

export default observer(function JobListHeader({ vm, scrollOffset }: Props) {
  return (
    <SplitViewHeader compact scrollOffset={scrollOffset}>
      <SplitViewHeaderSearch
        onChange={vm.search}
        value={vm.searcher.searchText.value}
        placeholder="Search Jobs"
      />
    </SplitViewHeader>
  )
})
